module.exports = __webpack_public_path__ + "img/title.49d49dc1.gif";